import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    category_list: [],
    total_count: 0,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
